import type { LeadStatus } from '@up2stay/up2promo-api-client';
import { CountPill } from '@up2stay/up2promo-ui';

import {
  LEAD_STATUS_IDS,
  leadStatusAccent,
} from '@/core/components/leads/lead-status-colors';
import { cn } from '@/core/lib/utils';

export type LeadsStatusCounts = Record<LeadStatus, number> & { all: number };

type LeadsStatusPillsProps = {
  selected: readonly LeadStatus[];
  counts: LeadsStatusCounts;
  statusLabels: Record<string, string>;
  allLabel: string;
  onSelectAll: () => void;
  onToggleStatus: (status: LeadStatus) => void;
  className?: string;
};

/** Status filter strip — domain wrapper over ui CountPill. */
export function LeadsStatusPills({
  selected,
  counts,
  statusLabels,
  allLabel,
  onSelectAll,
  onToggleStatus,
  className,
}: LeadsStatusPillsProps) {
  const allActive = selected.length === 0;

  return (
    <div
      className={cn(
        'flex min-w-0 items-center gap-1.5 overflow-x-auto',
        className,
      )}
      role="group"
      aria-label={allLabel}
    >
      <CountPill
        active={allActive}
        label={allLabel}
        count={counts.all}
        onClick={onSelectAll}
      />
      {LEAD_STATUS_IDS.map((status) => {
        const count = counts[status] ?? 0;
        const active = selected.includes(status);
        return (
          <CountPill
            key={status}
            active={active}
            label={statusLabels[status] ?? status}
            count={count}
            dimmed={!allActive && !active && count === 0}
            dotColor={leadStatusAccent(status)}
            onClick={() => onToggleStatus(status)}
          />
        );
      })}
    </div>
  );
}
